const SOUND_MUTED_KEY = 'woof-woof:notifications:muted';

export function getSoundMutedPreference(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.localStorage.getItem(SOUND_MUTED_KEY) === 'true';
}

export function setSoundMutedPreference(isMuted: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(SOUND_MUTED_KEY, String(isMuted));
}

export function getSoundMutedStorageKey(): string {
  return SOUND_MUTED_KEY;
}
